module.exports = __webpack_public_path__ + "img/instagram_logo.75a4fb21.png";